import { NgModule } from '@angular/core';

import { CommitteeService, EventService, FileReaderService, SettingService } from './services';

@NgModule({
  providers: [CommitteeService, EventService, FileReaderService, SettingService],
})
export class CoreModule {}
